import { ReactNode } from 'react';
import { ExternalLink } from '../../../assets/icons';
import { IconSize } from '../../../constant/IconSize.constant';
import { ColorType, Icon } from '../../_ui';

interface OutboundLinkProps {
  href: string;
  children: ReactNode;
  /** tel: and mailto: links should open in place */
  openInNewTab?: boolean;
  className?: string;
}

// Links sit inside a selectable result card, so clicking one must not also select the card
export const OutboundLink = ({
  href,
  children,
  openInNewTab = true,
  className = '',
}: OutboundLinkProps) => (
  <a
    href={href}
    {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
    className={`text-brand3 hover:underline break-words ${className}`}
    onClick={(e) => e.stopPropagation()}
  >
    {children}
  </a>
);

/** Bold external link with an "opens elsewhere" icon, used for the card's actions */
export const OutboundActionLink = ({
  label,
  ...linkProps
}: Omit<OutboundLinkProps, 'children' | 'className' | 'openInNewTab'> & { label: string }) => (
  <OutboundLink
    {...linkProps}
    className='inline-flex items-center gap-1 text-xs font-semibold font-inter'
  >
    {label}
    <Icon src={ExternalLink} size={IconSize.SIZE_12x12} color={ColorType.BRAND3} />
  </OutboundLink>
);
